import { buildSpendSummaryRows } from '@/dashboards/SpendSummary/helpers/buildSpendSummaryRows';
import { useRoiConfig } from '@/dashboards/SpendSummary/hooks/useRoiConfig';
import { useSpendSummaryContext } from '@/dashboards/SpendSummary/hooks/useSpendSummaryContext';
import { useMemo } from 'react';

/**
 * The table's rows and footer ROI for the current breakdown and filter
 * selection. All the arithmetic lives in `buildSpendSummaryRows`; this only
 * binds it to context.
 */
export const useSpendSummaryTableRows = () => {
    const { calculate } = useRoiConfig();
    const { spendSummaryData, selectedFilterNodes, modelBreakdown } =
        useSpendSummaryContext();

    return useMemo(
        () =>
            buildSpendSummaryRows({
                modelBreakdown,
                spendSummaryData,
                selectedFilterNodes,
                calculate,
            }),
        [calculate, modelBreakdown, selectedFilterNodes, spendSummaryData],
    );
};
